import { render, staticRenderFns } from "./SidebarMenuInfo.vue?vue&type=template&id=41a3a0fd&scoped=true&"
import script from "./SidebarMenuInfo.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuInfo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMenuInfo.vue?vue&type=style&index=0&id=41a3a0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a3a0fd",
  null
  
)

export default component.exports